"use strict";
/**
 * 限制数值范围
 *
 * ### Example
 * ```
 * range(2, [1, 3]);  // 2
 * range(0, [1, 3]);  // 1
 * range(5, [1, 3]);  // 3
 * ```
 */
Object.defineProperty(exports, "__esModule", { value: true });
function range(num, arr) {
    return Math.min(Math.max(num, arr[0]), arr[1]);
}
exports.range = range;
